/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2014-2018, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

/**
 * Controller for Unsupported Browser Alert.
 */
angular.module('bulbApp.alertsModule')
  .controller('UnsupportedBrowserAlertController', [
    '$cookies', 'BulbAuthService', 'BulbBrowserService', 'ALERT',
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    UnsupportedBrowserAlertController,
  ]);

function UnsupportedBrowserAlertController($cookies, BulbAuthService, BulbBrowserService, ALERT) {
  const that = this;

  /**
   * Message containing link, containing message, to be inserted in Unsupported Browser Alert message.
   * @type {object}
   */
  this.supportedBrowsersPath = 'supported-browsers';

  // Set primary value that controls whether this alert is visible.
  this.isBrowserSupported = BulbBrowserService.isSupported();
  this.usingFacebookOrInstagramInAppBrowser = BulbBrowserService.isFacebookOrInstagramInAppBrowser();

  // Verify that user is logged in before showing alerts.
  this.isLoggedIn = BulbAuthService.currentUser.isAuthenticated();

  const cookie = $cookies.get(ALERT.UNSUPPORTED_BROWSER.COOKIE_NAME);

  if (cookie) {
    this.hasSeenUnsupportedBrowserAlert = true;
  } else if (this.isLoggedIn) {
    if (this.isBrowserSupported || this.usingFacebookOrInstagramInAppBrowser) {
      // No cookie, and browser is supported: Set secondary value so that alert is NOT visible,
      // set cookie, and don't bother checking again for one year.
      $cookies.put(ALERT.UNSUPPORTED_BROWSER.COOKIE_NAME, true.toString(), {
        secure: true,
        samesite: 'None',
        expires: new Date(Date.now() + 24 * 60 * 60 * 1000 * ALERT.UNSUPPORTED_BROWSER.COOKIE_EXPIRES),
      });
      this.hasSeenUnsupportedBrowserAlert = true;
    } else {
      // No cookie and browser is not supported: Set secondary value so that alert is visible.
      this.hasSeenUnsupportedBrowserAlert = false;
    }
  } else {
    // if user is not logged in they don't need to see any of this
    // set secondary value so that alert is NOT visible
    this.hasSeenUnsupportedBrowserAlert = true;
  }

  /**
   * Define close function: Add cookie indicating that this alert has been dismissed.
   */
  this.close = function close() {
    $cookies.put(ALERT.UNSUPPORTED_BROWSER.COOKIE_NAME, true.toString(), {
      secure: true,
      samesite: 'None',
    });
    // Set secondary value so that alert is NOT visible.
    that.hasSeenUnsupportedBrowserAlert = true;
  };
}
